import { Intent, Position, Toaster } from "@blueprintjs/core";

import ServiceRegistry from "core/util/ServiceRegistry";
import { IActionResult } from "../../core/actions/IActionResult";
import Topic from "./entity/Topic";
import TopicFlag from "./entity/TopicFlag";
import TopicUpvote from "./entity/TopicUpvote";
import TopicDownvote from "./entity/TopicDownvote";
import TopicBookmark from './entity/topicBookmark';

/** Singleton toaster instance. Create separate instances for different options. */
export const ForumToaster = Toaster.create({
	className: "forum-toaster",
	position: Position.TOP
});

export const upvoteTopic = (topic: Topic): Promise<void> => {
	const mutationService = ServiceRegistry.getMutationService();
	const upvoted = { id: topic.id } as any;
	return mutationService.update(upvoted, TopicUpvote).then(() => {
		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "Post upvoted"
		});
	});
	//return new Promise<Topic>(console.log.bind("downvoted this post"));
};

export const dowvoteTopic = (topic: Topic): Promise<void> => {
	const mutationService = ServiceRegistry.getMutationService();
	const downvoted = { id: topic.id } as any;
	return mutationService.update(downvoted, TopicDownvote).then(() => {
		ForumToaster.show({
			intent: Intent.SUCCESS,
			message: "Post downvoted"
		});
	});

	//return new Promise<Topic>(console.log.bind("downvoted this post"));
};
export const bookmarkTopic = (topic: Topic): Promise<void> => {
    const mutationService = ServiceRegistry.getMutationService();
	const bookmarkId = { id: topic.id} as any;
    return mutationService.update( bookmarkId , TopicBookmark).then(() => {
		if(topic.bookmark===null)
		{ForumToaster.show({
            intent: Intent.SUCCESS,
            message: "Post bookmarked"
		});}
		else{
			ForumToaster.show({
				intent: Intent.SUCCESS,
				message: "Post unbookmarked"
			});
		}
    });
};

export const flagTopic = (topic: Topic, reason: string): Promise<void> => {
	const mutationService = ServiceRegistry.getMutationService();
	const flag = { id: topic.id, flagMessage: reason, flagType: "" } as any;

	return mutationService.create(flag, TopicFlag).then(() => {
		ForumToaster.show({
			intent: Intent.DANGER,
			message: "Post flagged"
		});
	});
};



// WEBPACK FOOTER //
// ./src/panels/forum/forumActions.ts